import { resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "pr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
    width: "500"
  }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createVNode(_component_v_list_item, _mergeProps(activatorProps, { onClick: _ctx.open }), {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.burgermenuActive = false)),
            textContent: _toDisplayString(_ctx.$t('archiv.table.burgermenu.edit'))
          }, null, 8, ["textContent"])
        ]),
        _: 2
      }, 1040, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_FocusLock, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "headline font-weight-bold mb-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('archiv.editdialog.title')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pb-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.dokumentCopy.bezeichnung,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dokumentCopy.bezeichnung) = $event)),
                      autofocus: "",
                      label: _ctx.$t('archiv.table.header.dokumentname'),
                      placeholder: _ctx.$t('archiv.table.header.dokumentname')
                    }, null, 8, ["modelValue", "label", "placeholder"]),
                    (_ctx.dokumentTyp == 'archiv.dokumenttyp.eigenesdok' || _ctx.dokumentTyp == 'archiv.dokumenttyp.buchhaltung')
                      ? (_openBlock(), _createBlock(_component_v_combobox, {
                          key: 0,
                          modelValue: _ctx.selectedSchlagworte,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSchlagworte) = $event)),
                            _ctx.onSelectedSchlagworteChanged
                          ],
                          search: _ctx.schlagwortSearchString,
                          "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.schlagwortSearchString) = $event)),
                          class: "mt-3",
                          items: _ctx.schlagwortDropdownList,
                          label: _ctx.$t('upload.table.schlagworte'),
                          "hide-no-data": !_ctx.schlagwortSearchString,
                          "bg-color": "white",
                          "hide-selected": "",
                          solo: "",
                          multiple: "",
                          "clear-on-select": true,
                          "custom-filter": _ctx.customFilter,
                          onKeydown: _withKeys(_withModifiers(_ctx.simulateEnter, ["prevent"]), ["space"])
                        }, {
                          selection: _withCtx(({ attrs, item, selected, index }) => [
                            _createVNode(_component_v_chip, _mergeProps(attrs, {
                              "input-value": selected,
                              label: "",
                              small: "",
                              closable: "",
                              "onClick:close": ($event: any) => (_ctx.deleteSchlagwortFromSelection(index, item.raw))
                            }), {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_1, _toDisplayString(item.value), 1)
                              ]),
                              _: 2
                            }, 1040, ["input-value", "onClick:close"])
                          ]),
                          item: _withCtx(({ props, item, index }) => [
                            (item.raw.header && _ctx.search)
                              ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mr-3" }, "Create", -1)),
                                    _createVNode(_component_v_chip, {
                                      size: "small",
                                      variant: "flat",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.search), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (item.raw.header)
                                ? (_openBlock(), _createBlock(_component_v_list_subheader, {
                                    key: 1,
                                    title: item.title
                                  }, null, 8, ["title"]))
                                : (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 2,
                                    onClick: props.onClick
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        icon: "mdi-delete",
                                        size: "small",
                                        variant: "text",
                                        onClick: _withModifiers(($event: any) => (_ctx.deleteSchlagwortFromDropdown(index, item.raw)), ["stop","prevent"])
                                      }, null, 8, ["onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_chip, {
                                        text: item.raw,
                                        variant: "outlined"
                                      }, null, 8, ["text"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "search", "items", "label", "hide-no-data", "custom-filter", "onUpdate:modelValue", "onKeydown"]))
                      : (_openBlock(), _createBlock(_component_v_text_field, {
                          key: 1,
                          modelValue: _ctx.dokumentCopy.schlagworte,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dokumentCopy.schlagworte) = $event)),
                          label: _ctx.$t('archiv.table.header.beschreibung'),
                          placeholder: _ctx.$t('archiv.table.header.beschreibung'),
                          readonly: "",
                          disabled: ""
                        }, null, 8, ["modelValue", "label", "placeholder"])),
                    _createVNode(_component_v_text_field, {
                      label: _ctx.$t('archiv.editdialog.dateiname'),
                      placeholder: _ctx.$t('archiv.editdialog.dateiname'),
                      "model-value": _ctx.fullDokumentName,
                      readonly: "",
                      disabled: ""
                    }, null, 8, ["label", "placeholder", "model-value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "ml-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      type: "submit",
                      color: "primary",
                      variant: "flat",
                      class: "modalbutton mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.save')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "modalbutton mb-3",
                      variant: "flat",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.visible = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}